import React, { useContext } from 'react'

interface metadata {
  introWidgets?: any[]
  isMobile: boolean
}

const MetadataContext = React.createContext<metadata>({
  isMobile: false,
})

export const useMetadataContext = (): metadata => {
  const context = useContext(MetadataContext)
  if (!context) {
    throw new Error('useMetadataContext must be used within a MetadataContext.Provider')
  }
  return context
}

export const MetadataProvider: React.FC<{ value: metadata }> = ({ children, value }) => {
  return <MetadataContext.Provider value={value}>{children}</MetadataContext.Provider>
}
